"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MediaItem = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _contexts = require("../../contexts");
var _models = require("../../models");
var _utils = require("../../utils");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const MediaItem = ({
  index,
  item: {
    id,
    mediaType,
    caption,
    products,
    uploader,
    images
  },
  showDetails,
  position
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    hideCaption
  } = (0, _contexts.useOlapicData)();
  const isSlider = position < _models.MediaItemPosition.gallery;
  const eventMeta = (0, _react.useMemo)(() => ['Olapic', 'Popup opened', mediaType, id, index.toString(), products?.join(',') ?? ''], [id, index, products, mediaType]);
  const onClick = (0, _react.useCallback)(clickedItemId => () => showDetails(clickedItemId, eventMeta), [eventMeta, showDetails]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    position: position,
    className: "olapic-media-sizes",
    "data-testid": getTestId(_constants.MEDIA),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Inner, {
      position: position,
      role: "button",
      tabIndex: 0,
      "data-testid": getTestId(`${_constants.MEDIA_BUTTON}-${id}`),
      onClick: onClick(id),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Image, {
        alt: "",
        "data-testid": getTestId(_constants.MEDIA_IMAGE),
        src: images.mobile,
        loading: "lazy"
      }), mediaType === 'video' ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.PlayIcon, {
        testId: getTestId(`${_constants.MEDIA_IS_VIDEO}-${id}`)
      }) : null, /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.OverlayElement, {
        component: "p",
        variant: "h6",
        className: "olapic-media-overlay",
        children: ["@", uploader.name]
      })]
    }), isSlider ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Description, {
      className: "olapic-media-description",
      children: !hideCaption && caption ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.DescriptionCaption, {
          "data-testid": getTestId(_constants.MEDIA_DESCRIPTION),
          children: (0, _utils.prepareDescription)(caption)
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Typography, {
          variant: "caption",
          children: ["@", uploader.name]
        })]
      }) : null
    }) : null]
  });
};
exports.MediaItem = MediaItem;
